import React from "react";

export default function NoOrder() {
  return (
    <div className="row no-margin h-fullscreen">
      <div className="col-12">
        <div className="card card-transparent mx-auto text-center">
          <span className="text- fs-90 material-icons-outlined">
            remove_shopping_cart
          </span>
          <h3 className="text-uppercase">No order at the moment</h3>
          <p className="lead">Reload page if this seems Error!</p>
        </div>
      </div>
    </div>
  );
}
